// extracted by mini-css-extract-plugin
export var cardBGGrey = "blogList-module--cardBGGrey--184ca";
export var cardContent = "blogList-module--cardContent--6f3e0";
export var cardExtraNoBorder = "blogList-module--cardExtraNoBorder--e8283";
export var cardText = "blogList-module--cardText--8cfb1";
export var franchiseLogoList = "blogList-module--franchiseLogoList--f8bd1";